import { all, call, delay, race, select, take } from 'redux-saga/effects';

import { fetchAutocode } from 'data-providers/autocode';
import * as CarInstanceConstants from 'store/carInstance/constants';
import * as CarInstanceSagas from 'store/carInstance/sagas';
import * as CarInstanceSelectors from 'store/carInstance/selectors';
import { SKIP_SYMBOL } from 'store/constants';
import { selectWhen } from 'store/helpers';
import { middlewareManager } from 'store/store';
import * as UserSelectors from 'store/user/selectors';

import * as InsuranceConstants from '../../constants';
import * as InsuranceHelpers from '../../helpers';

export const insuranceStageVinRecognition = new InsuranceHelpers.CreateStage({
  action: InsuranceConstants.ACTIONS.VIN_RECOGNITION,
  after: function* () {
    const { error } = yield race({
      success: all([
        take(CarInstanceConstants.ACTIONS.SET_CAR_INSTANCE),
        take(CarInstanceConstants.ACTIONS.SET_PATCHIG_CAR_INSTANCE),
      ]),
      error: delay(
        10 * 1000,
        'Не удалось загрузить данные. Заполните сведения о транспортном средстве вручную'
      ),
    });

    middlewareManager.setContext(CarInstanceSagas.watchPatchCarInstance, { [SKIP_SYMBOL]: false });

    if (error) {
      InsuranceHelpers.CreateStage.throwError({ message: error });
    }
  },
  before: function* () {
    // Ждем когда car instance заполнится
    yield selectWhen(CarInstanceSelectors.selectFetch, false);

    middlewareManager.setContext(CarInstanceSagas.watchPatchCarInstance, { [SKIP_SYMBOL]: true });
  },
  handler: function* () {
    const frontUserCredmenId = yield select(UserSelectors.getUserId);
    const {
      [CarInstanceConstants.VALUE_FIELDS.BRAND]: brandName,
      [CarInstanceConstants.VALUE_FIELDS.ID]: carInstanceId,
      [CarInstanceConstants.VALUE_FIELDS.IS_NEW]: isNew,
      [CarInstanceConstants.VALUE_FIELDS.VIN]: carNumber,
    } = yield select(CarInstanceSelectors.selectValues);

    if (!carNumber) {
      InsuranceHelpers.CreateStage.throwError({ message: 'VIN is required' });
    }

    yield call(fetchAutocode, {
      brandName: brandName || '',
      carInstanceId,
      carNumber,
      frontUserCredmenId,
      isNew,
      searchType: 1,
    });
  },
  name: InsuranceConstants.STAGES_FIELDS.VIN_RECOGNITION,
}).watcher;
